export default __webpack_public_path__ + "resources/icons/d140-3b21.png";